import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@material-ui/core';
import SingleFeedbackVisualizer from './single-feedback-visualizer';

const styles = {
  wrapper: {
    display: 'flex',
  },
  wrapperSmall: {
    display: 'flex',
    flexDirection: 'column',
  },
};

const FeedbackVisualizer = ({ options, data }) => {
  const useDesktopLayout = useMediaQuery('(min-width:1200px)');

  const feedbacks = data[0];
  const categories = {};
  feedbacks.data.forEach((d) => {
    categories[d.name] = categories[d.name] || {};
    // eslint-disable-next-line prefer-destructuring
    categories[d.name][d.values[0]] = d.values[1];
  });

  return (
    <div key={useDesktopLayout ? 'desktop' : 'mobile'} style={useDesktopLayout ? styles.wrapper : styles.wrapperSmall}>
      {Object.keys(categories).map(categoryKey => (
        <SingleFeedbackVisualizer
          key={categoryKey}
          categoryKey={categoryKey}
          options={options}
          category={categories[categoryKey]}
        />
      ))}
    </div>
  );
};

FeedbackVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

FeedbackVisualizer.defaultProps = {
  data: [],
  options: [],
};

export default FeedbackVisualizer;
